module.exports = __webpack_public_path__ + "img/horizontal_6_4_7016.b0fc76f1.png";